import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {NgClass, NgIf, NgStyle, NgTemplateOutlet, NgFor} from '@angular/common';
import {MatDialogModule} from '@angular/material/dialog';
import {ColorClickDirective} from '../directives/color-click.directive';
import {additionalPalette} from '../../../shared/constants/color-picker.constants';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    MatButtonModule,
    MatMenuModule,
    NgStyle,
    NgTemplateOutlet,
    NgFor,
    ColorClickDirective,
    TranslateModule,
    MatDialogModule
  ]
})
export class ColorPickerComponent {
  @Input() noMenu;
  @Input() text;
  @Input() color;
  @Input() palette = additionalPalette;

  @Output() colorPicked: EventEmitter<any> = new EventEmitter();

  public defaultColor = '#12345';

  throwUp(color) {
    this.color = color;
    this.colorPicked.emit(color);
  }
}
